function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { themeGet, space, borderRadius } from 'styled-system';
import { applySizes, applyVariations, color, deprecatedColorValue, deprecatedPropType, borderRadiusAttrs } from '../utils';

var type = function type(props) {
  var badgeColors = {
    blue: {
      backgroundColor: props.theme.colors.blue,
      color: props.theme.colors.white
    },
    lightBlue: {
      backgroundColor: props.theme.colors.lightBlue,
      color: props.theme.colors.darkBlue
    },
    green: {
      backgroundColor: props.theme.colors.green,
      color: props.theme.colors.white
    },
    lightGreen: {
      backgroundColor: props.theme.colors.lightGreen,
      color: props.theme.colors.darkGreen
    },
    red: {
      backgroundColor: props.theme.colors.red,
      color: props.theme.colors.white
    },
    lightRed: {
      backgroundColor: props.theme.colors.lightRed,
      color: props.theme.colors.darkRed
    },
    orange: {
      backgroundColor: props.theme.colors.orange,
      color: props.theme.colors.text
    },
    gray: {
      backgroundColor: props.theme.colors.gray,
      color: props.theme.colors.white
    },
    lightGray: {
      backgroundColor: props.theme.colors.lightGray,
      color: props.theme.colors.text
    }
  };
  return !(props.bg && props.color) && (badgeColors[props.bg] || badgeColors.lightGray);
};

var sizes = {
  small: css(["", " line-height:", ";"], themeGet('textStyles.small'), themeGet('lineHeights.display')),
  medium: css(["", " line-height:", ";"], themeGet('textStyles.display0'), themeGet('lineHeights.standard'))
};
var Badge = styled.div.attrs(borderRadiusAttrs).withConfig({
  displayName: "Badge",
  componentId: "sc-18cbb4q-0"
})(["display:inline-block;text-transform:uppercase;letter-spacing:", ";", ";", ";", " ", " ", ";", ""], themeGet('letterSpacings.caps'), function (_ref) {
  var theme = _ref.theme;
  return applySizes(sizes, undefined, theme.mediaQueries);
}, applyVariations('Badge'), space, type, color, borderRadius);
Badge.displayName = 'Badge';
Badge.propTypes = _objectSpread(_objectSpread({}, space.propTypes), {}, {
  size: PropTypes.oneOf(Object.keys(sizes)),
  color: deprecatedColorValue(),
  bg: deprecatedPropType('color')
});
Badge.defaultProps = {
  size: 'medium',
  px: 2,
  py: 1,
  borderRadius: 'full'
};
export default Badge;